import template from './template.html';
import controller from './controller';

routes.$inject = ['$stateProvider', '$urlRouterProvider'];

export default function routes($stateProvider, $urlRouterProvider){

	$stateProvider.state('main.panel.users', {
		url: '/users',
		template: template,
		controller: controller,
		controllerAs: 'vm'
	});

}


/** WEBPACK FOOTER **
 ** ./src/main/panels/panel/users.component/routes.js
 **/